import React from 'react';

import { useGlobalStore } from '../../stores/useGlobalStore';

import { HomepageOnboardingLauncher } from './launcher/HomepageOnboardingLauncher';
import { UnratedOnboardingLauncher } from './launcher/UnratedOnboardingLauncher';

export const OnboardingRoot: React.FC = () => {
  const activeOnboardingKey = useGlobalStore((state) => state.activeOnboardingKey);

  switch (activeOnboardingKey) {
    case 'home':
      return <HomepageOnboardingLauncher />;
    case 'unrated':
      return <UnratedOnboardingLauncher />;
    default:
      return null;
  }
};
